import React, { FC, ReactNode } from 'react';
import { PillStyled } from './GuestPill.styles';

type GuestPillProps = {
  label: ReactNode;
  isActive: boolean;
  onClick: (...args: any[]) => any;
};

export const GuestPill: FC<GuestPillProps> = ({ label, isActive, onClick }) => (
  <PillStyled type="button" onClick={onClick} isPrimary={isActive}>
    {label}
  </PillStyled>
);
